import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class InventoryApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.INVENTORY);
  }

  updateInventoryQuantity(inventoryId, data) {
    return this.httpClient.put(
      `${this.getResourceUrl()}${inventoryId}/quantity/`,
      data,
    );
  }

  addInventoryQuantity(inventoryId, data) {
    return this.httpClient.patch(
      `${this.getResourceUrl()}${inventoryId}/quantity/`,
      data,
    );
  }

  exportInventory(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }

  getInventoryHistoryList(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}history/?${queryString}`
      : `${this.getResourceUrl()}history/`;

    return this.httpClient.get(url);
  }

  getInventoryLedgerExport({ startDate, endDate } = {}) {
    const params = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    });

    return this.httpClient.get(
      `${this.getResourceUrl()}ledger/export/?${params.toString()}`,
    );
  }

  getInventoryHistoryExport(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}history/export/?${queryString}`
      : `${this.getResourceUrl()}history/export/`;

    return this.httpClient.get(url);
  }
}

export default new InventoryApi();
